<template>
    <Breadcrumbs main="Bonus Ui" title="Range Slider" />
    <div class="container-fluid">
        <div class="row">
            <defultRang />
            <minMax />
            <prefixRang />
            <negativeRang />
            <stepsRange />
            <customRang />
            <prettifyRang />
            <colorRang />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const defultRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/defultRang.vue"))
const minMax = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/minMax.vue"))
const prefixRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/prefixRang.vue"))
const negativeRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/negativeRang.vue"))
const stepsRange = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/stepsRange.vue"))
const customRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/customRang.vue"))
const colorRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/colorRang.vue"))
const prettifyRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/prettifyRang.vue"))
</script>